import { inject, Injectable } from '@angular/core';
import { Query } from '@datorama/akita';

import { IntegrationsState, IntegrationsStore } from './integrations.store';

@Injectable({ providedIn: 'root' })
export class IntegrationsQuery extends Query<IntegrationsState> {
  protected store: IntegrationsStore;

  constructor() {
    const store = inject(IntegrationsStore);

    super(store);

    this.store = store;
  }
}
